import Omega from 'Omega'
/**
 * 页面完全加载
 */
export const onLoad = (callback: () => void) =>
  document.readyState === 'complete'
    ? callback()
    : document.addEventListener('load', callback)

/**
 *
 * @returns
 */
export const URL = {
  _cache: null as any,
  _$_() {
    if (this._cache) {
      return this._cache
    }

    return (this._cache = new URLSearchParams(
      window.location.search
    ))
  },
  get(key: string) {
    return this._$_().get(key)
  },
  toJSON() {
    const params: { [key: string]: string } = {}
    for (const [key, value] of this._$_().entries()) {
      params[key] = value
    }
    return params
  },
  toString() {
    return JSON.stringify(this.toJSON())
  },
}

function getENV() {
  return {
    os: (() => {
      try {
        return Omega.selfReport.context.osType.toLowerCase()
      } catch (e) {
        return 'android'
      }
    })(),
    version: (() => {
      try {
        return Omega.selfReport.context.osVersion
      } catch (e) {
        return 'unknown'
      }
    })(),
  }
}
export const ENV = getENV()
console.groupCollapsed('[Mobile Detected]')
console.log(ENV)
console.groupEnd()

/**
 * Hyphenate a camelCase string.
 */
const hyphenateRE = /\B([A-Z])/g
export const hyphenate = (str: string) => {
  return str.replace(hyphenateRE, '-$1').toLowerCase()
}

/**
 * 是否是MGM渠道
 * @note 多环境支持，只要是mgm开头的都算mgm
 */
export const isMgm = () =>
  window.__INIT_STATE__.resource
    .toLowerCase()
    .startsWith('mgm')

/**
 * 是否来源为web-marketing，此来源执行免登逻辑
 */
export const isWebMarketing = () =>
  URL.get('fromPage') === 'web-marketing'

export const preventDefault = (event: Event) => {
  event.preventDefault()
  event.stopPropagation()
  event.stopImmediatePropagation()
}
